import React from "react";
import PropTypes from "prop-types";
import styles from "./index.module.css";

export function Pagination({ page, totalPages, onPageChange, ariaLabel }) {
  const pageNumbers = React.useMemo(() => {
    const span = 5;
    const start = Math.max(1, Math.min(page - 2, totalPages - span + 1));
    const end = Math.min(totalPages, start + span - 1);
    const numbers = [];
    for (let number = start; number <= end; number += 1) {
      numbers.push(number);
    }
    return numbers;
  }, [page, totalPages]);

  if (totalPages <= 1) return null;

  const go = (nextPage) => {
    const clampedPage = Math.min(Math.max(1, nextPage), totalPages);
    if (clampedPage !== page) onPageChange(clampedPage);
  };

  return (
    <div className={styles.paginationBar}>
      <nav className={styles.pagination} aria-label={ariaLabel}>
        <button
          type="button"
          className={styles.pageBtn}
          onClick={() => go(page - 1)}
          disabled={page <= 1}
          aria-label="Previous page"
        >
          ‹ Prev
        </button>

        {pageNumbers[0] > 1 && <span className={styles.pageEllipsis}>…</span>}

        {pageNumbers.map((number) => (
          <button
            key={number}
            type="button"
            className={`${styles.pageBtn} ${
              number === page ? styles.pageBtnActive : ""
            }`}
            onClick={() => go(number)}
            aria-current={number === page ? "page" : undefined}
          >
            {number}
          </button>
        ))}

        {pageNumbers[pageNumbers.length - 1] < totalPages && (
          <span className={styles.pageEllipsis}>…</span>
        )}

        <button
          type="button"
          className={styles.pageBtn}
          onClick={() => go(page + 1)}
          disabled={page >= totalPages}
          aria-label="Next page"
        >
          Next ›
        </button>
      </nav>
    </div>
  );
}

Pagination.propTypes = {
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  ariaLabel: PropTypes.string,
};

Pagination.defaultProps = {
  ariaLabel: "Pages",
};

export default Pagination;
